import {useRef,useState} from 'react';
import {openProFenzOperations} from './api';

export function ProFenzJobsEntry({onOpened=()=>window.location.assign('/company/new-file')}:{onOpened?:()=>void}){
  const [pending,setPending]=useState(false);
  const [error,setError]=useState('');
  const submitting=useRef(false);
  async function open(){
    if(submitting.current)return;
    submitting.current=true;setPending(true);setError('');
    try{
      await openProFenzOperations();
      // A full navigation reloads authenticated context and existing company
      // capabilities. It never mounts intake with the former admin context.
      onOpened();
    }catch{
      setError('ProFenz job entry could not be opened. Reload your workspace and try again.');
    }finally{submitting.current=false;setPending(false);}
  }
  return <div>
    <button type="button" className="button-link" disabled={pending} onClick={open}>{pending?'Opening ProFenz jobs…':'New ProFenz job'}</button>
    <p className="form-note">Create a job in ProFenz’s own workspace.</p>
    {error&&<p role="alert">{error}</p>}
  </div>;
}
